"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const AlertBase_1 = tslib_1.__importDefault(require("../../../ui-lib/Alerts/AlertBase"));
const errorAlertClasses = {
    root: {
        backgroundColor: "#f54248",
        color: "#00000",
    },
};
const ModularErrorAlert = (0, mobx_react_lite_1.observer)(({ error, children, classes, ...props }) => {
    const [active, setActive] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (error != null) {
            setActive(true);
        }
    }, [error]);
    if (error == null) {
        return null;
    }
    function DefaultMessage() {
        return react_1.default.createElement("p", { style: { margin: 0 } },
            " Error: ", error === null || error === void 0 ? void 0 :
            error.code,
            " ");
    }
    return (react_1.default.createElement(AlertBase_1.default, { classes: classes || errorAlertClasses, ...props, active: active, setActive: setActive }, children !== null && children !== void 0 ? children : react_1.default.createElement(DefaultMessage, null)));
});
exports.default = ModularErrorAlert;
//# sourceMappingURL=ErrorAlert.js.map